import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Brain, BarChart, Calendar, ShoppingBag, MessageCircle } from 'lucide-react';
export function ProductExperience() {
  const features = [{
    icon: <Brain className="w-5 h-5 text-charcoal" data-id="element-664" data-mp="1hdlfmc2b30cg" />,
    title: 'AI-Tailored Wellness Plans',
    desc: 'Intelligent pathways that adapt to your evolving health data and goals.'
  }, {
    icon: <BarChart className="w-5 h-5 text-charcoal" data-id="element-665" data-mp="293q8kz44svpa" />,
    title: 'Personal Health Analytics',
    desc: 'A beautiful, intuitive dashboard to track your progress and outcomes.'
  }, {
    icon: <Calendar className="w-5 h-5 text-charcoal" data-id="element-666" data-mp="20aec0h6rshb0" />,
    title: 'Seamless Booking',
    desc: 'Frictionless scheduling with our vetted network of practitioners.'
  }, {
    icon: <ShoppingBag className="w-5 h-5 text-charcoal" data-id="element-667" data-mp="2s09d1b3zpvfi" />,
    title: 'Curated Marketplace',
    desc: 'Exclusive access to premium wellness services and products.'
  }, {
    icon: <MessageCircle className="w-5 h-5 text-charcoal" data-id="element-668" data-mp="1o827zqi4x7b0" />,
    title: 'Private Community Layer',
    desc: 'Connect with peers in a secure, moderated, and supportive environment.'
  }];
  return <Section background="ivory" data-id="element-669" data-mp="1xxltl3x8ff9k">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center" data-id="element-670" data-mp="1xywv0x37gaxi">
        <div className="lg:col-span-5" data-id="element-671" data-mp="1t4ivqjlf9jnk">
          <FadeIn data-id="element-672" data-mp="26x8lmz42n8py">
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6 leading-tight" data-id="element-673" data-mp="26wqtadkj5enb">
              Designed for Precision, <br data-id="element-674" data-mp="22v57u3txjs1i" />
              <span className="italic text-charcoal/60" data-id="element-675" data-mp="22vne7tab3mn5">Built for Care</span>
            </h2>
            <p className="text-lg text-charcoal/70 mb-8" data-id="element-676" data-mp="2gv6b1pxo3bk5">
              Not just features — these are the capabilities of a premium
              ecosystem designed to anticipate and serve your wellness needs
              seamlessly.
            </p>
          </FadeIn>
        </div>

        <div className="lg:col-span-7" data-id="element-677" data-mp="hjvphx644qzx">
          <div className="space-y-4" data-id="element-678" data-mp="hkx0k1n4pdhn">
            {features.map((feature, idx) => <FadeIn key={idx} delay={idx * 150} data-id="element-679" data-mp="2hmwkk1p0r8uw" data-mpi={idx}>
                <div className="group flex items-start p-6 rounded-2xl transition-all duration-300 hover:bg-white hover:shadow-lg hover:shadow-purple-200/40 border border-transparent hover:border-purple-200" data-id="element-680" data-mp="2mj4vf2w6ofw9">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center mr-6 flex-shrink-0 group-hover:bg-purple-200 transition-colors" data-id="element-681" data-mp="2vlntzasxs6cp">
                    {feature.icon}
                  </div>
                  <div data-id="element-682" data-mp="35gxz47emstup">
                    <h3 className="text-xl font-serif text-charcoal mb-2" data-id="element-683" data-mp="35gfw8rxgrhdt">
                      {feature.title}
                    </h3>
                    <p className="text-charcoal/60 leading-relaxed" data-id="element-684" data-mp="3ebce08v922da">
                      {feature.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </Section>;
}